import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExitWarningIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 74,
	height: 74,
	viewBox: "0 0 74 74",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 37,
			cy: 37,
			r: 37,
			fill: "#FF8075",
			fillOpacity: .45
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 37.0003,
			cy: 37.4202,
			r: 30.2727,
			fill: "#EA4335"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.887 31.9541L31.1143 43.7268M31.1143 31.9541L42.887 43.7268",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgExitWarningIcon;
